import React, { createContext, useContext } from 'react';

const StorageBoxSidebarDrawerContext = createContext(null);

export function StorageBoxSidebarDrawerProvider({ onItemNavigate, children }) {
  const close = typeof onItemNavigate === 'function' ? onItemNavigate : () => {};
  return (
    <StorageBoxSidebarDrawerContext.Provider value={close}>{children}</StorageBoxSidebarDrawerContext.Provider>
  );
}

export function useStorageBoxSidebarDrawer() {
  return useContext(StorageBoxSidebarDrawerContext) ?? (() => {});
}
